"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaTokenService = exports.MediaTokenService = void 0;
var media_token_service_1 = require("./media-token.service");
Object.defineProperty(exports, "MediaTokenService", { enumerable: true, get: function () { return media_token_service_1.MediaTokenService; } });
Object.defineProperty(exports, "mediaTokenService", { enumerable: true, get: function () { return media_token_service_1.mediaTokenService; } });
